import { useCallback, useEffect, useState } from 'react'
import { ActivityIndicator, Platform } from 'react-native'

import { i18n } from '@localization'
import { publishEvent } from '@zet/analytics'
import { useAddCustomerNextStateWeb } from '@zet/customer'
import { useAgentDetailsWF } from '@zet/customer/src/api/hooks/webFlow'
import { H5, SH3, Stack } from '@zet/design-system'
import Lottie from 'lottie-react'
import LottieView from 'lottie-react-native'

import ScreenViewEventWrapper from '../../../components/screenViewEventWrapper'

const OtpLessVerification = () => {
  const { mutate } = useAddCustomerNextStateWeb()
  const [isVerified, setIsVerified] = useState(false)
  const params = new URLSearchParams(window.location.search)
  const hash = params.get('hash') || localStorage.getItem('hash') || ''
  if (params.get('hash')) {
    localStorage.setItem('hash', params.get('hash'))
  }
  const { data } = useAgentDetailsWF({
    hash: encodeURIComponent(hash),
  })

  const verifyLink = useCallback(() => {
    mutate(
      {
        screenName: 'SHOWN_OTP_LESS_SCREEN',
        customerId: data?.customer.customerId,
        event: 'OTP_LESS_VERIFICATION',
        isOtpLess: true,
      },
      {
        onSuccess() {
          publishEvent('screen_view', {
            screen_name: 'web_new_add_customer_consent_screen_success',
          })
          setIsVerified(true)
        },
      }
    )
  }, [data?.customer, mutate])

  useEffect(() => {
    if (data?.customer.customerId) verifyLink()
  }, [data?.customer, verifyLink])

  if (!isVerified) {
    return (
      <Stack className="h-[80%] justify-center">
        <ActivityIndicator size={'large'} />
      </Stack>
    )
  }
  return (
    <ScreenViewEventWrapper screenName="web_new_add_customer_consent_screen">
      <Stack className="items-center">
        {Platform.OS === 'web' ? <Lottie animationData={require('../../../../../assets/lottie/Verified.json')} /> : 
        <LottieView
          autoPlay
          style={{ height: 220, width: 220 }}
          source={require('../../../../../assets/lottie/Verified.json')}
        /> }
        <H5 className="text-grays-100 px-4 text-center">
          {i18n.t('otpLessConsentWebVerification.thanksForConsent', {
            customerName: data?.customer?.fullName,
          })}
        </H5>
        <SH3 className="text-grays-60 mt-2 px-4 text-center">
          {i18n.t('otpLessConsentWebVerification.connectWithAdvisor')}
        </SH3>
      </Stack>
    </ScreenViewEventWrapper>
  )
}

export default OtpLessVerification
